import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { RiDraftLine, RiPhoneLine } from 'react-icons/ri';
import {
	Button,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Stack,
} from '@chakra-ui/react';
import { v4 as uuid } from 'uuid';

import { useAuth } from '../../hooks/auth';
import { Input } from '../Inputs/Input';

type PhoneFormData = {
	numero: string;
	obs?: string;
}
type PhoneData = {
  id: string;
  numero: string;
  obs?: string;
  emp_cod: string;
}

interface NewTelClienteModalProps {
	isOpen: boolean;
	onRequestClose: () => void;
	setPhones: (phone: PhoneData[]) => void;
	phones: PhoneData[];
	phoneModal: PhoneData;
	setPhoneModal: (phone: PhoneData) => void;
}

const clientFormSchema: yup.SchemaOf<PhoneFormData> = yup.object().shape({
	numero: yup.string().required('Número obrigatório.'),
	obs: yup.string(),
});

const NewPhoneClienteModal: React.FC<NewTelClienteModalProps> = ({
	isOpen,
	onRequestClose,
	setPhones,
	phones,
	phoneModal,
	setPhoneModal,
}) => {
	const { company } = useAuth();

	const { register, handleSubmit, formState, setValue, reset } = useForm<PhoneFormData>({
		resolver: yupResolver(clientFormSchema)
	});

	useEffect(() => {
		reset(phoneModal);
	}, []);

	function handleMaskPhone(event: string) {
		let res = event;
		res = res.replace(/\D/g, '');
		res = res.replace(/^(\d{2})(\d)/g, '($1) $2');
		res = res.replace(/(\d)(\d{4})$/, '$1-$2');
		setValue('numero', res);
	};

	const handleSubmitPhone: SubmitHandler<PhoneFormData> = async (data) => {
		if (phoneModal.id) {
			const endIndex = phones.findIndex(end => end.id === phoneModal.id);
			phones[endIndex] = {
        ...data,
        id: phones[endIndex].id ? phones[endIndex].id : '',
        emp_cod: phones[endIndex].emp_cod ? phones[endIndex].emp_cod : company.id
      };

			setPhones(phones);
		} else {
			const phone = { ...data, id: uuid(), emp_cod: company.id };
			setPhones([...phones, phone]);
		}

		setPhoneModal({} as PhoneData);
		reset();
		onRequestClose();
	}

	return (
		<Modal
			isCentered={true}
			closeOnOverlayClick={false}
			blockScrollOnMount={false}
			size="lg"
			isOpen={isOpen}
			onClose={onRequestClose}
		>

			<ModalOverlay />
			<ModalContent as="form" onSubmit={handleSubmit(handleSubmitPhone)}>
				<ModalHeader>Novo Telefone</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Stack>
						<Input
							label="Número"
							iconLabel={RiPhoneLine}
              bgColor="gray.50"
							{...register("numero")}
							maxLength={15}
							error={formState.errors.numero}
							onChange={(e: any) => handleMaskPhone(e.target.value)}
						/>

						<Input
							label="Observação"
							iconLabel={RiDraftLine}
              bgColor="gray.50"
							{...register("obs")}
							error={formState.errors.obs}
						/>
					</Stack>
				</ModalBody>

				<ModalFooter>
					<Button colorScheme='blue' mr={3} type="submit">
						Salvar
					</Button>
					<Button
						variant='ghost'
						onClick={() => {
							reset();
							onRequestClose();
						}}
					>
						Cancelar
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}

export default NewPhoneClienteModal;

/*
<Modal
			isOpen={isOpen}
			onRequestClose={onRequestClose}
			overlayClassName="react-modal-overlay"
			className="react-modal-content"
		>
			<button
				type='button'
				onClick={onRequestClose}
				className="react-modal-close"
			>
				<Icon as={RiCloseLine} fontSize="20" />
			</button>

			<Input
				label="Telefone"
        iconLabel={RiPhoneLine}
				error={formState.errors.phone}
				{...register("phone")}
			/>
		</Modal>
*/
